const STATUSES = {
  SENDING: 'sending',
  CONNECTED: 'connected',
  TOKEN_EXPIRED: 'token_expired',
} as const;

export default STATUSES;
